import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonLoading,
  IonButton,
  useIonViewWillEnter,
  IonList,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { useParams, useHistory } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import OrderCart from 'containers/order/OrderCart';

// @TODO handle edit order
function OrderCartPage() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  const loading = useSelector(OrderSelectors.selectMenuItemsLoading);
  const sending = useSelector(OrderSelectors.selectSending);
  const { locationId: venueId } = params;

  const handleAdd = () => {
    history.push(`/locations/${venueId}/cart/add`);
  };

  const handleSendOrder = () => {
    history.push(`/locations/${venueId}/cart/sendLocation`);
  };

  useIonViewWillEnter(() => {
    dispatch(OrderActions.loadMenuItems(venueId));
  });

  return (
    <PageLayout
      back
      title="Review Cart"
      footer={
        <IonButton
          color="tertiary"
          expand="block"
          fill="solid"
          onClick={handleSendOrder}
        >
          Send Order
        </IonButton>
      }
    >
      <IonLoading isOpen={sending || loading} message="Loading..." />
      <IonList>
        <IonItem>
          <IonLabel>
            <span className="ion-text-uppercase text-bold">
              Review Your Order
            </span>
          </IonLabel>
        </IonItem>
      </IonList>
      <section className="ion-v-padding ion-padding">
        <IonButton onClick={handleAdd} color="secondary" expand="full">
          Add More Items
        </IonButton>
      </section>
      <OrderCart venueId={venueId} />
    </PageLayout>
  );
}

export default OrderCartPage;
